import { FieldConfig } from "../../../components/form/FieldRenderer";

export const company: FieldConfig[] = [
  {
    name: "company_name",
    label: "Company Name",
    type: "text",
    required: true,
    placeholder: "Enter company name",
  },
  {
    name: "website",
    label: "Company Domain Name",
    type: "text",
    required: true,
    placeholder: "organization.com",
  },

  // Company Information
  {
    name: "company_phone",
    label: "Contact No.",
    type: "phone",
    required: false,
  },
  {
    name: "company_email",
    label: "Email ID",
    type: "email",
    required: true,
    placeholder: "support@organization.com",
  },

  // Company address
  {
    name: "company_street_address",
    label: "Street Address",
    type: "text",
    placeholder: "Enter Street Address",
  },
  {
    name: "company_country_id",
    label: "Country",
    type: "select",
    required: true,
    options: [],
    asyncOptions: true,
  },
  {
    name: "company_state_id",
    label: "State",
    type: "select",
    required: true,
    options: [],
    asyncOptions: true,
    dependsOn: "company_country_id",
  },
  {
    name: "company_city_id",
    label: "City",
    type: "select",
    required: true,
    options: [],
    asyncOptions: true,
    dependsOn: "company_state_id",
  },
  {
    name: "timezone",
    label: "Timezone",
    type: "select",
    required: true,
    options: [{ label: "-- Select Timezone --", value: "" }],
  },
  {
    name: "region_id",
    label: "Region",
    type: "select",
    required: true,
    options: [{ label: "-- Select Region --", value: "" }],
    asyncOptions: true,
  },
  {
    name: "company_postal_code",
    label: "Zip Code",
    type: "text",
    required: false,
  },
  { name: "tax_id", label: "Tax ID", type: "text" },
];

export const contact: FieldConfig[] = [
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    required: true,
    placeholder: "Enter First Name",
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    required: true,
    placeholder: "Enter Last Name",
  },
  {
    name: "corporate_email",
    label: "Corporate Email ID",
    type: "email",
    required: true,
    placeholder: "user@organization.com",
  },
  {
    name: "designation",
    label: "Designation",
    type: "text",
    required: true,
    placeholder: "Enter Designation",
  },
  {
    name: "position",
    label: "Position",
    type: "text",
    required: true,
    placeholder: "Enter Position",
  },
  {
    name: "mobile_phone",
    label: "Mobile No.",
    type: "phone",
    required: true,
    placeholder: "Enter Mobile No.",
  },
  {
    name: "work_phone_no",
    label: "Phone No.",
    type: "phone",
    required: false,
    placeholder: "Enter Phone No.",
  },
  {
    name: "street_address",
    label: "Street Address",
    type: "text",
    placeholder: "Enter Street Address",
  },
  {
    name: "country_id",
    label: "Country",
    type: "select",
    required: true,
    options: [],
    asyncOptions: true,
  },
  {
    name: "state_id",
    label: "State",
    type: "select",
    required: true,
    options: [],
    asyncOptions: true,
    dependsOn: "country_id",
  },
  {
    name: "city_id",
    label: "City",
    type: "select",
    required: true,
    options: [],
    asyncOptions: true,
    dependsOn: "state_id",
  },
  { name: "postal_code", label: "Zip Code", type: "text", required: false },
];

export const product: FieldConfig[] = [
  {
    name: "product",
    label: "Product",
    type: "select",
    required: true,
    options: [],
  },
  {
    name: "no_of_licenses",
    label: "No. of License",
    type: "text",
    required: true,
    placeholder: "Enter No. of License",
    numericOnly: true,
    suffixText: ({ watch }) => {
      const selectedPlanId = watch("billing_frequency");
      return selectedPlanId ? (
        <>
          ${"0.00"}/<span className="font-medium">per unit</span>
        </>
      ) : null;
    },
  },
  {
    name: "billing_frequency",
    label: "Billing Frequency",
    type: "select",
    required: true,
    options: [],
  },
];

export const paymentTop: FieldConfig[] = [
  {
    name: "total_paid_amount",
    label: "Total amount ($)",
    type: "text",
    required: true,
  },
  {
    name: "discount",
    label: "Discount(%)",
    type: "text",
    belowNote: ({ watch }) => {
      const amt = Number.parseFloat(watch("total_paid_amount") || "0");
      const dRaw = Number.parseFloat(watch("discount") || "0");
      const disc = Number.isNaN(dRaw) ? 0 : Math.min(dRaw, 100);
      const val = Number.isNaN(amt) ? "0.00" : (amt - (amt * disc) / 100).toFixed(2);
      return (
        <>
          After discount: <span className="font-bold">${val}</span>
        </>
      );
    },
  },
  {
    name: "payment_mode",
    label: "Payment Mode",
    type: "select",
    required: true,
    options: [
      { label: "-- Choose Payment method --", value: "" },
      { label: "By Cheque", value: "by-cheque" },
      { label: "Cash", value: "cash" },
    ],
  },
  { name: "transaction_ref", label: "Transaction ID", type: "text" },
];

export const paymentDates: FieldConfig[] = [
  {
    name: "date_of_payment",
    label: "Date of payment",
    type: "date",
    required: true,
    gridSpan: 2,
  },
  {
    name: "expiration_date",
    label: "Subscription expiration date",
    type: "date",
    required: true,
    gridSpan: 2,
    minFrom: "date_of_payment",
  },
];
